import React, { Component } from 'react';
import { Input, Button } from 'antd';

export default class Requirements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isEditable: false,
      selectedItem: ''
    };
  }
  componentWillReceiveProps(nextProps) {
    const { items } = nextProps;
    if (
      Array.isArray(items) &&
      Array.isArray(this.state.items) &&
      items.length !== this.state.items.length
    ) {
      this.setState({ items });
    }
  }

  handleSaveEditable(index) {
    const { items, selectedItem } = this.state;
    items[index] = selectedItem;
    this.setState(
      {
        items,
        selectedItem: '',
        isEditable: null
      },
      () =>
        this.props.handleSaveEditable({
          itemName: this.props.name,
          itemValue: this.state.items
        })
    );
  }

  handleEditableItem(index) {
    this.setState({ isEditable: index });
  }

  handleChange(value) {
    this.setState({ selectedItem: value });
  }
  handleDeleteItem(index) {
    const { items } = this.state;
    items.splice(index, 1);
    this.setState({ items });
  }

  renderItem(item, index) {
    return (
      <div key={item}>
        {this.state.isEditable === index ? (
          <div key={item}>
            <Input
              value={this.state.selectedItem}
              autoFocus
              onChange={e => this.handleChange(e.target.value, index)}
              onFocus={(e) => {
                e.target.value = item;
              }}
            />
            <Button
              onClick={() => this.handleSaveEditable(index)}
              style={{ marginRight: 10 }}
              className="btn-save"
              size="small"
              type="primary"
            >
              Save
            </Button>
            <Button
              onClick={() => this.handleEditableItem(null)}
              ghost
              className="btn-cancel"
              size="small"
              type="primary"
            >
              Cancel
            </Button>
          </div>
        ) : (
          <p>
            {item}
            <span className="controls">
              <Button
                onClick={() => this.handleEditableItem(index)}
                type="primary"
                shape="circle"
                icon="edit"
                size="small"
              />
              <Button
                onClick={() => this.handleDeleteItem(index)}
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </span>
          </p>
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.items.map((item, index) => this.renderItem(item, index))}
      </div>
    );
  }
}
